//3rd Party Components
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import { AUcallout } from '@gov.au/callout';
import { ExitModal } from '../../../components/CASAForm/ExitModal'
import AUdirectionLink from '@gov.au/direction-links';

//Components
import Question from '../../../components/CASAForm/Question';
import StepNavigation from '../../../components/CASAForm/StepNavigation';

//Actions
import { addNotificationType } from '../../../FormStore/Actions/FormDataActions/MPL/AddMPLFormData';
import { addPageAlert, clearPageAlert } from "../../../PortalStore/Actions/PageAlertActions";
import { getFormPropertiesSelector, getFormDataSelector } from "../../../FormStore/Selectors/FormDataSelectors";


class MPLNotificationTypeSelection extends Component {
    constructor(props) {
        super(props);

        let notificationType = '';
        let notificationTypeLabel = '';

        if (props.formData?.notificationType?.value) {
            notificationType = props.formData.notificationType.value;
            notificationTypeLabel = props.formData?.notificationType?.label;
        }

        this.state = {
            modal: false,
            notificationType: notificationType,
            notificationTypeLabel: notificationTypeLabel,
            showError: false,
            dirty: false,
            url: ''
        }

    }

    clickListener = (e) => {
        //if dirty show dialog box
        //if showing hide and bubble
        if (this.state.dirty && !this.state.modal) {
            e.preventDefault();
            this.setState({ url: e.target.getAttribute('href'), modal: true });
        }
        //if user cancels exit then hide dialog box and exit
        //if user oks exit then hide dialog box and bubble
    }

    cleanup = () => {
        document.querySelectorAll('a').forEach(item => {
            item.removeEventListener('click', this.clickListener);
        })
        window.removeEventListener("beforeunload", this.cleanup);
    }

    componentDidUpdate(prevProps) {
        window.addEventListener("beforeunload", this.cleanup);
        document.querySelectorAll('a').forEach(item => {
            item.addEventListener('click', this.clickListener);
        })
    }

    setDirty = () => {
        this.setState({ dirty: true });
    }

    addQuestionDataToState = (questionObject) => {
        this.setState({
            dirty: true
        })
    }

    returnTypeSelection = (returnedQuestion) => {
        this.setState({
            notificationType: returnedQuestion.answer.radioValue,
            notificationTypeLabel: returnedQuestion.answer.value,
            dirty: true
        })

    };

    showPrevPage = () => {
       
        return (
            <AUdirectionLink
                link={this.props.backurl}
                linkComponent='a'
                id="prevPage"
                text="Back"
                direction="left" />
        );
        
    }

    nextStep = (e) => {
        e.preventDefault();

        if (this.state.notificationType) {
            this.props.dispatch(addNotificationType({
                value: this.state.notificationType,
                label: this.state.notificationTypeLabel
            }))
            this.props.onNextClick(this.state.notificationType);

            this.props.pageAlert?.level && this.props.dispatch(clearPageAlert());

        } else {
            this.setState({showError: true})
            this.props.dispatch(addPageAlert({
                level: "error",
                title: "There was a problem with the form",
                message: "Please check the form below and try again"
            }));
        }
    }

    toggle = (e) => {
        e.preventDefault();

        this.setState({ modal: !this.state.modal });
    }

    //when user confirms exit then return to url in clicked link
    OK = (e) => {
        e.preventDefault();

        this.setState({ modal: !this.state.modal });

        if (location) {
            location.href = this.state.url;
        }
    }

    render() {
        const exitModalParams = {
            isOpen: this.state.modal,
            toggleFunction: this.toggle,
            OKFunction: this.OK
        }

        return (
            <div id={this.props.id}>
                <ExitModal exitModalParams={exitModalParams} />
                {this.showPrevPage()}

                <h2>Notification type</h2>

                <AUcallout
                    title=""
                    srOnlyTitle>
                    <p>Please note: this MTO Notification of training outcomes is the online equivalent of CASA Form 465.</p>
                </AUcallout>
                
                <Question
                    id="notificationType"
                    stepid="notificationType"
                    type="radio"
                    label="Please select one of the following notification types"
                    returnQuestionData={this.returnTypeSelection}
                    showError={this.state.showError}
                    setDirty={this.setDirty}
                    existingAnswer={{
                        value: this.state.notificationTypeLabel,
                        radioValue: this.state.notificationType
                    }}
                    radioSet={[
                        {
                            name: "notificationTrainingOutcome",
                            id: "notificationTrainingOutcome",
                            value: "notificationTrainingOutcome",
                            optionLabel: "MTO Notification of training outcomes for category or type"
                        },
                        {
                            name: "removalOfExclusion",
                            id: "removalOfExclusion",
                            value: "removalOfExclusion",
                            optionLabel: "Removal of exclusion from an existing category or type"
                        }
                    ]}/>
               
                <div className="form-controls au-form-group">
                    <StepNavigation
                        type='next'
                        action={this.nextStep}/>
                </div>
            </div>
        )

    }
}

MPLNotificationTypeSelection.propTypes = {
    properties: PropTypes.object,
    dispatch: PropTypes.func,
    onNextClick: PropTypes.func,
    id: PropTypes.string,
    pageAlert: PropTypes.object,
    formData: PropTypes.object,
    formProperties: PropTypes.object,
    B2CSettings: PropTypes.object,
    envdata: PropTypes.object,
    previousPageLink: PropTypes.string,
    backurl: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        formData: getFormDataSelector(state.formStore, 'mplFormData'),
        formProperties: getFormPropertiesSelector(state.formStore),
        envdata: state.envdata,
        B2CSettings: state.B2CSettings,
        pageAlert: state.pageAlert
    }
}

export default connect(mapStateToProps)(MPLNotificationTypeSelection);